import { Flame, Trophy, MessageCircle, Zap, CalendarDays } from "lucide-react";

const Card = ({ children, testId }) => <div className="p-surface p-4" data-testid={testId}>{children}</div>;
const Lbl = ({ children }) => <p className="text-[11px] font-bold uppercase tracking-[0.14em] p-t3">{children}</p>;

export const MatchPreview = () => (
  <Card testId="preview-match">
    <div className="flex items-center justify-between"><Lbl>NBA · Ce soir</Lbl><span className="flex items-center gap-1 text-xs font-bold p-accent"><CalendarDays size={12} /> 21H00</span></div>
    <div className="mt-3 grid grid-cols-2 gap-2">
      {[["RAPTORS", true], ["LAKERS", false]].map(([t, on]) => (
        <span key={t} className={`rounded-sm border px-3 py-3 text-center text-base font-bold ${on ? "border-[#B7F52A] bg-[#B7F52A] text-[#080C0D]" : "p-line"}`}>{t}</span>))}
    </div>
    <p className="mt-3 text-xs p-t3">Prono verrouillé au coup d'envoi · Match vedette : points doublés</p>
  </Card>
);

export const StandingsPreview = () => (
  <Card testId="preview-standings">
    <Lbl>Classement · Novembre</Lbl>
    <ol className="mt-2 divide-y p-line">{[["1", "Léa", 43, "+6"], ["2", "Karim", 41, "+2"], ["3", "Max", 38, "−1"], ["8", "Toi", 22, "+4"]].map(([r, n, p, d]) => (
      <li key={n} className={`flex items-center gap-3 py-2 ${n === "Toi" ? "font-bold" : ""}`}><span className="p-num w-6 text-xl">{r}</span><span className="flex-1 text-sm">{n}</span>
        <span className="text-xs p-t3">{d}</span><span className="p-num text-xl">{p}</span></li>))}</ol>
  </Card>
);

export const ChallengePreview = () => (
  <Card testId="preview-challenge">
    <div className="flex items-center gap-2"><Trophy size={16} className="p-accent" /><Lbl>Défi de la ligue</Lbl></div>
    <p className="mt-2 font-display text-3xl uppercase">Les croissants.</p>
    <p className="mt-1 text-sm p-t2">Le dernier du mois les apporte lundi. Accepté par 9 joueurs sur 10.</p>
    <div className="mt-3 h-1.5 rounded-full bg-[var(--p-raised)]"><div className="h-full w-3/4 rounded-full bg-[#B7F52A]" /></div>
    <p className="mt-1 text-xs p-t3">Encore 9 jours</p>
  </Card>
);

export const BonusPreview = () => (
  <Card testId="preview-bonus">
    <div className="flex items-center gap-2"><Zap size={16} className="p-accent" /><Lbl>Question bonus</Lbl></div>
    <p className="mt-2 text-base font-bold">Plus de 30 points pour le meilleur marqueur ?</p>
    <div className="mt-3 flex gap-2"><span className="rounded-full bg-[#B7F52A] px-4 py-1.5 text-sm font-bold text-[#080C0D]">Oui · +3</span><span className="rounded-full border p-line px-4 py-1.5 text-sm">Non</span></div>
    <p className="mt-2 text-xs p-t3">Mauvaise réponse : −3 selon le barème de la ligue</p>
  </Card>
);

export const BanterPreview = () => (
  <Card testId="preview-banter">
    <div className="flex items-center gap-2"><MessageCircle size={16} className="p-accent" /><Lbl>Activité</Lbl></div>
    <ul className="mt-2 space-y-2 text-sm">
      <li><b>Karim</b> <span className="p-t2">« 5 de suite, qui dit mieux ? »</span></li>
      <li><b>Léa</b> <span className="p-t2">« Je te rattrape ce soir. »</span></li>
      <li className="flex items-center gap-1 text-xs p-t3"><Flame size={12} /> Max entre dans le top 3</li>
    </ul>
  </Card>
);

export const BrandingPreview = () => (
  <Card testId="preview-branding">
    <div className="rounded-sm p-4" style={{ background: "#1B3A6B", color: "#FFFDF5" }}>
      <p className="text-[11px] font-bold uppercase tracking-[0.14em] opacity-80">Ton logo · tes couleurs</p>
      <p className="mt-1 font-display text-3xl uppercase">Ta ligue</p>
      <span className="mt-3 inline-block rounded-full px-3 py-1 text-xs font-bold" style={{ background: "#F2C230", color: "#0B1A33" }}>Rejoindre</span>
    </div>
    <p className="mt-2 text-xs p-t3">Nom, logo, couleurs, bannière et lots personnalisés</p>
  </Card>
);

export const ExperiencePreview = () => (
  <Card testId="preview-experience">
    <Lbl>Ma Petite Ligue Experiences</Lbl>
    <p className="mt-1 font-display text-4xl uppercase">Win<span className="p-accent"> New York.</span></p>
    <p className="mt-1 text-sm p-t2">Un weekend NBA à gagner · 2 gagnants</p>
    <p className="mt-2 text-xs p-t3">Exemple illustratif</p>
  </Card>
);

export const PREVIEWS = { match: MatchPreview, standings: StandingsPreview, challenge: ChallengePreview, bonus: BonusPreview, banter: BanterPreview, branding: BrandingPreview, experience: ExperiencePreview };
